import { render, staticRenderFns } from "./FrameBreak.vue?vue&type=template&id=64709d4e&scoped=true&"
import script from "./FrameBreak.vue?vue&type=script&lang=ts&"
export * from "./FrameBreak.vue?vue&type=script&lang=ts&"
import style0 from "./FrameBreak.vue?vue&type=style&index=0&id=64709d4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64709d4e",
  null
  
)

export default component.exports